import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Field, reduxForm, FormSection, change } from "redux-form"
import { Translate, getTranslate, getActiveLanguage } from "react-localize-redux"
import Loadable from "react-loadable"
import CardThumbnail from "../../images/logos/startbuckvn.png"
import get from "lodash.get"

import {
	createValidator,
	email,
	match,
	required,
	minLength,
	maxLength,
	password,
	isValidDate,
	integer,
	noVnChars,
	noSpecialChars,
	fixedLength,
	fixedLengthCard,
	fixedLengthCode,
} from "../../helpers/validator"
import CheckField from "../components/fields/CheckField"
import TextField from "../components/fields/TextField"
import DatePickerField from "../components/fields/DatePickerField"
import Button from "../components/forms/Button"

import scratch from "../../images/scratch.svg"
import { getSysCodeOptions } from "../../redux/modules/SystemCode"
import AsyncSelectField from "../components/fields/AsyncSelectField"
import { bindActionCreators } from "redux"
import Loading from "../components/shared/Loading"
import { normalizePhone, normalizeCardNo, cookieOptions } from "../../helpers"
import { withCookies } from "react-cookie/cjs"
import { Link } from "react-router-dom"
import { getStarbuckCard } from "../../redux/modules/Card"
import Reaptcha from "reaptcha"
import { recaptchaKey } from "../../configs"

const AsyncAddressSection = Loadable({
	loader: () => import("./AddressSection"),
	loading: Loading,
})

const validate = createValidator({
	email: [required, email],
	firstName: [required, noVnChars, noSpecialChars],
	lastName: [required, noVnChars, noSpecialChars],
	confirmPassword: [required, match("password")],
	password: [required, minLength(8), maxLength(15), password],
	cardNo: [required, fixedLengthCard(16), integer],
	securityCode: [required, fixedLengthCode(8), integer],
	dob: [required, isValidDate],
	mobileNo: [required, integer, minLength(9), maxLength(10)],
	countryCode: [required],
	// address: {
	// 	address1: [required, noVnChars],
	// 	city: [required],
	// 	district: [required],
	// 	ward: [required],
	// },
	consentAgreement: [],
	termsAndConditions: [required],
})

export const formId = "sign-up"
class SignUpForm extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			readOnlyFields: {},
			cardNo: "",
			isPhysicalCard: false,
			isValidCaptcha: false,
		}

		this.handleTncClick = this.handleTncClick.bind(this)
	}

	handleTncClick(url) {
		window.open(url, "_blank")
	}

	handleCaptchaSuccess = () => {
		this.setState({ isValidCaptcha: true })
	}

	handleCaptchaError = () => {
		this.setState({ isValidCaptcha: false })
	}

	componentDidMount() {
		const { cookies, cardInfo } = this.props
		const cardNo = get(cardInfo, "cardNo")
		const passcode = get(cardInfo, "passcode")

		if (cardNo && passcode) {
			this.props.change(formId, "cardNo", cardNo)
			this.props.change(formId, "securityCode", passcode.substr(0, 8))
			const readOnlyFields = { cardNo: true, securityCode: true }
			this.setState({ readOnlyFields }, () => {
				cookies.remove("dynamicLink", cookieOptions())
			})
		}
	}

	render() {
		const {
			error,
			handleSubmit,
			pristine,
			translate,
			submitting,
			getSysCodeOptions,
			currentLanguage,
		} = this.props
		const { readOnlyFields, isValidCaptcha } = this.state

		return (
			<form name="form" onSubmit={handleSubmit} className="row form">
				<div className="col-12">
					<Field
						name="salutation"
						type="text"
						parse={(option) => (option ? option.value : null)}
						loadOptions={() =>
							getSysCodeOptions(
								`${currentLanguage.toUpperCase()}Salutation`
							)
						}
						key={currentLanguage}
						searchable={false}
						disabled={submitting}
						component={AsyncSelectField}
						label={translate("_shared.form.label._salutation")}
					/>
					<Field
						name="firstName"
						type="text"
						autocomplete="given-name"
						required={true}
						disabled={submitting}
						component={TextField}
						label={translate("_shared.form.label._firstName")}
					/>
					<Field
						name="lastName"
						type="text"
						autocomplete="family-name"
						required={true}
						disabled={submitting}
						component={TextField}
						label={translate("_shared.form.label._lastName")}
					/>
					<Field
						name="email"
						type="email"
						autocomplete="email"
						required={true}
						disabled={submitting}
						component={TextField}
						label={translate("_shared.form.label._email")}
					/>
					<div className="row mb-3">
						<div className="col-12">
							<label className="font-sub color-text-2" data-required={true}>
								{translate("_shared.form.label._mobileNo")}
								{" :"}
							</label>
						</div>
						<div className="col-4 pr-1">
							<Field
								name="countryCode"
								type="text"
								autocomplete="country-code"
								disabled={true}
								required={true}
								component={TextField}
								hideLabel={true}
								label={translate("_shared.form.label._countryCode")}
							/>
						</div>
						<div className="col-8 pl-1">
							<Field
								name="mobileNo"
								type="text"
								normalize={normalizePhone}
								autocomplete="phone"
								disabled={submitting}
								required={true}
								component={TextField}
								hideLabel={true}
								minLength={9}
								maxLength={10}
								maxField={10}
								label={translate("_shared.form.label._mobileNo")}
								pattern="(0|[3|5|7|8|9])+([0-9]{8})\b"
							/>
						</div>
					</div>
					<Field
						name="dob"
						required={true}
						disabled={submitting}
						component={DatePickerField}
						disabledYear={true}
						label={translate("_shared.form.label._dob")}
					/>
					<Field
						name="password"
						type="password"
						autocomplete="new-password"
						component={TextField}
						required={true}
						disabled={submitting}
						minLength={8}
						maxLength={15}
						label={translate("_shared.form.label._password")}
					/>
					<div className="form-guide">
						<Translate id="signUp.form._passwordRules" />
					</div>
					<Field
						name="confirmPassword"
						type="password"
						component={TextField}
						disabled={submitting}
						match={translate("_shared.form.label._password")}
						label={translate("_shared.form.label._confirmPassword")}
					/>
					{/* <h5 className="color-text-2">
						<Translate id="profile.subTitle.addressInformation" />
					</h5> */}
					{/* <FormSection name="address" className="pb-3">
						<AsyncAddressSection
							formId={formId}
							isEditable={!submitting}
							requiredFields={{
								address1: true,
								city: true,
								district: true,
								ward: true,
							}}
						/>
					</FormSection> */}
					<div className="custom-control custom-switch ">
						<span className="fw-bold">
							<Translate id="sign._haveCard._title" />
						</span>

						<label className="lable-switch " style={{ float: "right" }}>
							<input
								className="switch-signup"
								type="checkbox"
								defaultChecked={this.state.isPhysicalCard}
								onClick={() => {
									this.props.change(formId, "cardNo", "")
									this.props.change(formId, "securityCode", "")
									this.setState({
										isPhysicalCard: !this.state.isPhysicalCard,
									})
								}}
							/>
							<span className="span-switch" />
						</label>
					</div>

					{this.state.isPhysicalCard ? (
						<div className="fieldset my-4 mx-sm--3">
							<div className="fieldset_header">
								<h4 className="fieldset_title f5">
									<Translate id="_shared.form._cardDetails" />
								</h4>
							</div>
							<div className="fieldset_content">
								<Field
									name="cardNo"
									type="text"
									normalize={normalizeCardNo}
									required={true}
									fixedLength={16}
									disabled={submitting}
									readOnly={readOnlyFields["cardNo"]}
									component={TextField}
									label={translate("_shared.form.label._cardNo")}
								/>
								<div className="form-guide">
									<Translate id="_shared.form._cardNoRules" />
								</div>
								<Field
									name="securityCode"
									type="password"
									pattern="\d*"
									autocomplete="new-password"
									required={true}
									fixedLength={8}
									disabled={submitting}
									readOnly={readOnlyFields["securityCode"]}
									component={TextField}
									label={translate("_shared.form.label._securityCode")}
								/>
								<div className="form-guide">
									<img
										src={scratch}
										alt={translate("signUp.form._Scratch")}
										className="w-25 pr-1"
									/>
									<span className="color-text-2">
										{translate("signUp.form._Scratch")}
									</span>
								</div>
							</div>
						</div>
					) : (
						<div className="row my-3">
							<div className="col-3 pr-0">
								<img
									src={CardThumbnail}
									alt=""
									className="img-fluid w-100"
								/>
							</div>
							<div className="col-9  pl-1 ">
								<p className="lh-6" style={{ fontSize: "0.7rem" }}>
									<Translate id="signUp._haveCard._decription" />
								</p>
							</div>
						</div>
					)}

					<div className="row px-3 px-xl-0 color-text-2">
						<Field
							id="consentAgreement"
							name="consentAgreement"
							type="checkbox"
							disabled={submitting}
							component={CheckField}
							text={translate("signUp.form.name._consentAgreement")}
							label={translate("signUp.form.label._consentAgreement")}
							className="font-sub"
						/>
						<div className="form-guide pl-4 ml-2">
							<Translate id="signUp.form._consentAgreementRules" />
							<span
								className="link link-primary fw-bold"
								onClick={() =>
									this.handleTncClick(
										translate("signUp.form._termOfUseLink")
									)
								}>
								<Translate id="signUp.form._termOfUse" />
							</span>
							<Translate id="signUp.form._consentAgreementRules2" />
						</div>
					</div>

					<Reaptcha
						sitekey={recaptchaKey}
						onVerify={this.handleCaptchaSuccess}
						onExpire={this.handleCaptchaError}
						onError={this.handleCaptchaError}
						className="my-2"
					/>

					{error && (
						<div className="my-2 text-left">
							<span className="form-error">{error}</span>
						</div>
					)}
				</div>

				<div className="col-12 text-right">
					<Button
						type="submit"
						className="btn btn-primary"
						disabled={pristine || !isValidCaptcha}
						loading={submitting}>
						<Translate id={submitting ? "_Submitting" : "_sign_up"} />
					</Button>
				</div>
			</form>
		)
	}
}

SignUpForm.propTypes = {
	handleSubmit: PropTypes.func.isRequired,
	translate: PropTypes.func.isRequired,
	invalid: PropTypes.bool.isRequired,
	submitting: PropTypes.bool.isRequired,
}

const mapStateToProps = ({ locale, egiftCardVerifyEgift }) => ({
	translate: getTranslate(locale),
	currentLanguage: getActiveLanguage(locale).code,
	cardInfo: egiftCardVerifyEgift.cardInfo,
})

const mapDispatchTpProps = (dispatch) => ({
	getSysCodeOptions: bindActionCreators(getSysCodeOptions, dispatch),
	change: bindActionCreators(change, dispatch),
})

export default reduxForm({
	form: formId, // a unique identifier for this form
	validate,
	enableReinitialize: true,
	destroyOnUnmount: false,
})(withCookies(connect(mapStateToProps, mapDispatchTpProps)(SignUpForm)))



// WEBPACK FOOTER //
// ./src/views/modules/SignUpForm.js